export default {
      id: "253,4=1,7+80+45+80+45+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#253,4=1,7+80+45+80+45+1,7",
      toString: function () {
        return this.url;
      }
    }